export default "__VITE_ASSET__DFr_NaQD__"